import React, { useState, useEffect } from 'react';
import { Link, useRouteMatch, Router, Switch, Route } from 'react-router-dom';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { LogoEditor } from './LogoEditor';
import { ScreenList } from './ScreenList';
import style from './Setting.module.css';
// import logo from '../../assets/images/logo_1.png';

function Setting({ id }: { id: string }) {
  const path = window.location.pathname;

  const buttons = [
    {
      id: 0,
      name: '大屏管理',
      url: `/${id}/setting`
    },
    {
      id: 1,
      name: '首页自定义',
      url: `/${id}/setting/welcome`
    },
    {
      id: 2,
      name: '空间自定义',
      url: `/${id}/setting/home`
    }
  ];

  return (
    <React.Fragment>
      <div className={style.bg}></div>
      <div className={style.container}>
        <header className={style.header}>
          <div className={style.header__bg}>
            <span className={style.header__decoration1}></span>
            <span className={style.header__decoration2}></span>
            <span className={style.header__decoration3}></span>
          </div>
          <div className={style.logo}>
            <img src="/logo_system.png" />
          </div>
          <Link to={`/${id}`} className={style.button_cockpit}>
            驾驶舱
          </Link>
        </header>

        <div className={style.container__content}>
          <div className={style.content_leftside}>
            <span className={style.leftside__corner}></span>
            {buttons.map((item, i) => {
              return (
                <Link
                  key={i}
                  to={item.url}
                  className={classnames(style.button_nav, { [style['button_nav--selected']]: path === item.url })}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>
          <div className={style.content_rightside}>
            <Switch>
              <Route exact path={`/${id}/setting/welcome`} render={() => <LogoEditor type="welcome" />}></Route>
              <Route exact path={`/${id}/setting/home`} render={() => <LogoEditor type="home" />}></Route>
              <Route component={ScreenList}></Route>
            </Switch>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default connect<any, any, any, Cockpit.Store>((state) => ({ id: state.id }))(Setting);
